import { memo, useEffect, useState } from "react"
import { Badge, Button, Card, HStack, Input, Stack, Text } from "@chakra-ui/react"
import { formatCurrency } from "@/utilities/number"
import { useApp } from "contexts/app"
import BottomSheet from "components/bottom-sheet"

import OrderService from "services/order"
import { useNavigate, useSearchParams } from "react-router"
import WithLoginPage from "@/components/withlogin"
import moment from "moment";
const service = new OrderService();

const statusOptions = [
    { value: "payment_pending", label: "Cần thanh toán" },
    { value: "shipping", label: "Đang vận chuyển" },
    { value: "finalized", label: "Đã hoàn tất" },
    { value: "all", label: "Tất cả" },
];

const Cart = () => {
    const { setProcessing, setPageTitle } = useApp();
    const [searchParams, setSearchParams] = useSearchParams();
    const status = searchParams.get('status');
    const currentStatus = status || "all";

    const navigate = useNavigate();
    const [orders, setOrders] = useState([])
    const [codeKeyword, setCodeKeyword] = useState("");
    const [openStatusFilter, setOpenStatusFilter] = useState(false);
    useEffect(() => {
        setPageTitle("Đơn hàng")
    }, [setPageTitle])

    useEffect(() => {
        loadData();

    }, [currentStatus])

    const loadData = async () => {
        setProcessing(true);
        var data = await service.list({ status: currentStatus });
        setProcessing(false)
        if (data) {
            setOrders(data);
        }
    }

    const filteredOrders = (orders || []).filter((item) => {
        const keyword = String(codeKeyword || "").trim().toLowerCase();
        if (!keyword) {
            return true;
        }
        return String(item?.id || "").toLowerCase().includes(keyword);
    });

    const getStatusMeta = (item = {}) => {
        if (item.status === "canceled") {
            return { label: "Đã huỷ", color: "red" };
        }
        if (item.status === "finalized") {
            return { label: "Đã hoàn tất", color: "green" };
        }
        return { label: item.payment_status?.title || "Đang xử lý", color: "orange" };
    };

    const currentStatusLabel = statusOptions.find((x) => x.value === currentStatus)?.label || "Tất cả";













    return (
        <div style={{ paddingBottom: 75 }}>

            <div >


                <Stack gap="3" align="stretch" maxW="sm">
                    <Card.Root size="sm">
                        <Card.Body>
                            <Stack gap={2}>
                                <Input
                                    placeholder="Tìm theo mã đơn..."
                                    value={codeKeyword}
                                    onChange={(e) => setCodeKeyword(e.target.value)}
                                />
                                <Button variant="ghost" justifyContent="space-between" onClick={() => setOpenStatusFilter(true)}>
                                    Trạng thái: {currentStatusLabel}
                                </Button>
                            </Stack>
                        </Card.Body>
                    </Card.Root>

                    {filteredOrders.length === 0 && (
                        <Card.Root size="sm">
                            <Card.Body>
                                <Text color="fg.muted">Chưa có đơn hàng.</Text>
                            </Card.Body>
                        </Card.Root>
                    )}

                    {filteredOrders.map((item) => {
                        const statusMeta = getStatusMeta(item);
                        return (
                            <Card.Root key={item.id} size="sm" onClick={e => navigate(`/order/${item.id}`)} style={{ cursor: "pointer" }}>
                                <Card.Body>
                                    <Stack gap={2}>
                                        <HStack justify="space-between" align="start">
                                            <Stack gap={1}>
                                                <Text fontWeight="bold">Mã đơn: {item.id}</Text>
                                                <Text color="fg.muted" fontSize="sm">{moment(item.create_on).format("DD/MM/YYYY HH:mm")}</Text>
                                            </Stack>
                                            <Badge colorPalette={statusMeta.color}>{statusMeta.label}</Badge>
                                        </HStack>

                                        <HStack justify="space-between">
                                            <Text color="fg.muted">Tổng tiền</Text>
                                            <Text fontWeight="bold">{formatCurrency(item.total_amount)}</Text>
                                        </HStack>
                                    </Stack>
                                </Card.Body>
                            </Card.Root>
                        );
                    })}
                </Stack>

                <BottomSheet open={openStatusFilter} onOpenChange={(e) => setOpenStatusFilter(e)} title="Chọn trạng thái">
                    <Stack gap={2}>
                        {statusOptions.map((option) => (
                            <Button
                                key={option.value}
                                variant={currentStatus === option.value ? "solid" : "outline"}
                                onClick={() => {
                                    setSearchParams({ status: option.value });
                                    setOpenStatusFilter(false);
                                }}
                            >
                                {option.label}
                            </Button>
                        ))}
                    </Stack>
                </BottomSheet>



            </div>



        </div >
    )
}

const withLogin = () => (<WithLoginPage><Cart></Cart></WithLoginPage>)


export default memo(withLogin)